import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex justify-center items-center min-h-[70vh] p-4">
      <div className="bg-green-50 rounded-lg shadow-md flex flex-col items-center text-center p-10 gap-4">
        <h2 className="text-green-800 text-2xl font-semibold m-0">
          404 - Not Found
        </h2>
        <p className="text-gray-700 text-sm max-w-md m-0">
          Oops! The page you're looking for doesn't exist or has been moved.
        </p>
        
        <button
                  className="mt-8 text-white px-8 py-3 rounded-lg font-semibold hover:opacity-90 transition-colors bg-brand-green"
                  onClick={() => navigate("/")}
                  >
                  Go to Home
                </button>
      </div>
    </div>
  );
};

export default NotFound;
